// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EllipsisText_wrapper__1uw22"};